import { useMutationWithRefresh } from '../useMutationWithRefresh';
import supplierService, { SupplierForm } from '../../services/supplierService';
import { queryKeys } from '../../queryClient';

// สร้างผู้จำหน่าย
export const useCreateSupplier = (options?: { skipSuccessMessage?: boolean }) => {
  return useMutationWithRefresh({
    mutationFn: (data: SupplierForm) => supplierService.createSupplier(data),
    invalidateKeys: [
      queryKeys.suppliers.all,
      queryKeys.devices.all, // devices อาจแสดง dropdown ผู้จำหน่าย
    ],
    successMessage: options?.skipSuccessMessage ? undefined : 'สร้างผู้จำหน่ายสำเร็จ',
  });
};

// แก้ไขผู้จำหน่าย
export const useUpdateSupplier = () => {
  return useMutationWithRefresh({
    mutationFn: ({ id, data, ifMatch }: { id: number; data: Partial<SupplierForm>; ifMatch?: string }) =>
      supplierService.updateSupplier(id, data, ifMatch),
    invalidateKeys: [
      queryKeys.suppliers.all,
      queryKeys.devices.all, // devices แสดงชื่อผู้จำหน่าย
    ],
    successMessage: 'แก้ไขผู้จำหน่ายสำเร็จ',
  });
};

// ลบผู้จำหน่าย
export const useDeleteSupplier = () => {
  return useMutationWithRefresh({
    mutationFn: (id: number) => supplierService.deleteSupplier(id),
    invalidateKeys: [
      queryKeys.suppliers.all,
      queryKeys.dashboard.summary, // dashboard อาจแสดงจำนวนผู้จำหน่าย
    ],
    successMessage: 'ลบผู้จำหน่ายสำเร็จ',
  });
};

// เปลี่ยนสถานะผู้จำหน่าย
export const useToggleSupplierStatus = () => {
  return useMutationWithRefresh({
    mutationFn: (id: number) => supplierService.toggleSupplierStatus(id),
    invalidateKeys: [
      queryKeys.suppliers.all,
      queryKeys.devices.all,
    ],
    successMessage: 'เปลี่ยนสถานะผู้จำหน่ายสำเร็จ',
  });
};
